//External
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { get_cookie } from "utils";

//Internal
import SingleSlider from "../../components/sliders/single-slider";

/*******************
  @Purpose : used for car card
  @Parameter : { row, slugUrl }
  @Author : INIC
  *******************/
const CarCard = ({ row, slugUrl, flag, saveHandler, onCardClick }) => {
  const is_mobile_app = get_cookie("is_mobile_app");
  const userToken = useSelector((state1) => state1?.user);
  const titleRef = useRef(null);
  const [isTitleTruncated, setIsTitleTruncated] = useState(false);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return undefined;

    const measure = () => setIsTitleTruncated(el.scrollWidth > el.clientWidth + 1);
    measure();
    document?.fonts?.ready?.then(measure);

    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [row?.name]);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/

  return (
    <>
      <div className="slider-box">
        <div className="box-images">
          {(is_mobile_app !== "yes" ||
            (is_mobile_app === "yes" && userToken?.token)) && (
            <span
              className="save-btn icon"
              onClick={() => saveHandler(row.id, row.slug)}
              style={{ cursor: "pointer" }}
            >
              <svg
                className={`${
                  row.is_favourite ? "icon-fill-heart" : "icon-empty-heart"
                }`}
                id={"f_" + row.id}
                viewBox="0 0 32 32"
                aria-hidden="true"
                role="presentation"
                focusable="false"
              >
                <path d="m16 28c7-4.733 14-10 14-17 0-1.792-.683-3.583-2.05-4.95-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05l-2.051 2.051-2.05-2.051c-1.367-1.366-3.158-2.05-4.95-2.05-1.791 0-3.583.684-4.949 2.05-1.367 1.367-2.051 3.158-2.051 4.95 0 7 7 12.267 14 17z"></path>
              </svg>
            </span>
          )}
          <SingleSlider
            data={row?.all_images}
            slugUrl={slugUrl}
            flag={flag}
            onLinkClick={onCardClick ? () => onCardClick(row) : undefined}
          />
        </div>
        <div className="d-flex justify-content-between box-detail">
          <h5 className="d-flex flex-column mb-0 overflow-hidden pr-1">
            <span className="text-uppercase font-16 ff-hel-reg car-brand text-black">
              {" " + row.brand_detail.title}
            </span>
            <OverlayTrigger
              placement="top"
              trigger={isTitleTruncated ? ["hover", "focus"] : []}
              overlay={
                <Tooltip id={`car-title-tooltip-${row.id}`} className="car-title-tooltip">
                  {row.name}
                </Tooltip>
              }
            >
              <span
                className="font-22 ff-hel-reg car-title text-black text-truncate"
                ref={titleRef}
              >
                {" " + row.name}
              </span>
            </OverlayTrigger>
          </h5>

          <div className="d-flex flex-column car-price">
            {row.real_price ? (
              <>
                <span className="font-22 text-right ff-hel-reg car-price-value text-primary">
                  ${row.day}
                </span>
                <small className="font-16 text-black">
                  <del>${row.real_price}</del>/day
                </small>
              </>
            ) : (
              <>
                <span className="font-22 text-right ff-hel-reg car-price-value discount-price text-black">
                  ${row.day}
                </span>
                <small className="font-16 text-right text-black font-weight-normal">
                  per day
                </small>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CarCard;
